module.exports = __webpack_public_path__ + "static/media/line-up-astro.e58189a0.png";